//routes
import MainRoute from "./routes/MainRoute";

//style
import GlobalStyle from "./constants/style";

function App() {
  return (
    <>
      <MainRoute />
      <GlobalStyle />
    </>
  );
}

export default App;
